module.exports = __webpack_public_path__ + "resources/img/bg_toastcloud_center_v2.3b830e60c30707c1c10c4e6fb3cfab6b.png";